'use client'

import { IconSizes, InfoErrorIcon } from '../../icons'
import React from 'react'

export interface FormInputValidationText {
    children: React.ReactNode
}

export const FormInputValidationText = ({ children }: FormInputValidationText) => (
    <span className="text-error-700 text-sm" data-testid="form-input-error">
        {children}
        <InfoErrorIcon size={IconSizes.SMALL} className="inline ml-1 -mt-1" />
    </span>
)
